import React , { useState } from 'react'
import './Header.css';

import { NavLink } from 'react-router-dom';


const JoinUs = () => {
  const [click , setClick] = useState(false);
    
    const handleClick = () => setClick(!click);
  return (
    <>
    <div className='h-[calc(100vh-6.5rem)]  px-32 flex flex-col justify-between items-center bg-background bg-no-repeat bg-[length:80%-100%] sm:bg-left-top lg:bg-contain lg:pt-5'>
          {/* List */}
            <div className={click ? "flex xl:flex items-center lg:justify-between md:justify-between w-full relative menu" 
            : "flex xl:flex items-center lg:justify-between md:justify-between w-full relative menu open" }
                  >
                <NavLink to="/">
                    <img src="/assets/icons/tg_logo.svg" alt="" 
                       className={click ? "sm:absolute sm:right-10 sm:top-11 md:right-12 md:top-12 logo"
                    : "sm:absolute sm:right-10 sm:top-11 md:right-12 md:top-12  sm:hidden md:hidden lg:block logo" } />
                </NavLink>
                <div 
                className='xl:hidden lg:hidden text-5xl flex  sm:absolute sm:left-10 sm:top-11 md:left-11 md:top-12 z-30 text-gray'
                  onClick={handleClick}   >
                    <i className={click ? "fa-solid fa-bars" : "fa-solid fa-xmark"}></i>
                </div>
                <ul className={click ? "flex xl:flex lg:flex justify-between w-3/4 text-lg lg:text-lg md:text-sm listItems sm:hidden md:hidden lg:pl-20 lg:-mr-[20%]" 
                : "flex xl:flex justify-between w-3/4 text-lg lg:text-lg md:text-lg listItems lg:pl-16 lg:pr-8" }>
                    <li><NavLink to="/"  className='link link-underline link-underline-black hover:cursor-pointer '>الصفحة الرئيسية</NavLink></li>
                    <li><a href="#about-us"  className='link link-underline link-underline-black hover:cursor-pointer'>من نحـن</a></li>
                    {/* <li><NavLink to="/AboutUs"  className='link link-underline link-underline-black hover:cursor-pointer'>من نحـن</NavLink></li> */}
                    <li><a href="#services"  className='link link-underline link-underline-black hover:cursor-pointer'>ماذا نقـدم</a></li>
                   <li><a  href="#features"  className='link link-underline link-underline-black hover:cursor-pointer'>المسـارات</a></li>
                    <li><a href="#ourwok"  className='link link-underline link-underline-black hover:cursor-pointer'>أعمالنـا</a></li>
                    <li><a href="#ourteam"  className='link link-underline link-underline-black hover:cursor-pointer'>فريقنـا</a></li>
                </ul>

             
            </div>
      <div className='p-10 sm:p-0 sm:m-0 sm:w-[90vw] sm:leading-[3rem] md:leading-[4] sm:translate-y-14 text-center flex flex-col sm:pt-12 items-center mx-auto h-[75vh]'>

        <h2 className='xl:text-5xl md:text-4xl sm:text-xl sm:w-full sm:pb-6 md:pb-12  font-black text-center sm:mt-[30%] md:mt-[20%] lg:mt-[5%] xl:mt-[3%]'>ترقب إطلاق منصتنا التعليمة قريبا ...</h2>
        <h2 className='xl:text-4xl md:text-3xl sm:text-lg sm:mb-6 md:mb-12 sm:mt-2'>لمعرفة موعد الافتتاح وإطلاق المسارات </h2>
        <p className='xl:text-3xl md:text-3xl  font-black bg-orange sm:px-3 sm:py-1 md:px-5 md:py-2 rounded-lg sm:mb-6 md:mb-10 sm:leading-8 md:leading-[3rem]'>تابعنا على مواقع التواصل</p>
        <div className='flex flex-row-reverse mb-2 xl:mt-2'>
          <a className='px-5 sm:px-3 md:px-5 cursor-pointer' href='https://www.facebook.com/tg.academy0/' target='_blank' rel='noreferrer'><img className='w-8 sm:w-6 md:w-10' src="assets/icons/media/facebook.svg" alt="" /></a>
          <a className='px-5 sm:px-3 md:px-5 cursor-pointer' href='https://t.me/TG_Academyy' target='_blank' rel='noreferrer'><img className='w-8 sm:w-6 md:w-10' src="assets/icons/media/telegram.svg" alt="" /></a>
          <a className='px-5 sm:px-3 md:px-5 cursor-pointer' href='https://www.linkedin.com/company/thegame-academy/' target='_blank' rel='noreferrer'><img className='w-8 sm:w-6 md:w-10' src="assets/icons/media/linkedinIcon.svg" alt="" /></a>
        </div>
      </div>
    </div> 
    </>
  )
}

export default JoinUs;


